<template lang="pug">
  div(data-testid="agent-set")
    section.content-header
      h1 代理操作ユーザー指定
      ol.breadcrumb
        li
          router-link(:to="{name: 'top'}")
            span.glyphicon.glyphicon-home
            | TOP
        li.active 代理操作ユーザー指定

    section.content
      app-messages(:errorMessages="errors", :successMessages="successes")

      form(@submit.prevent="postData")

        mixin btnbar
          .bcard-btnbar(class!=attributes.class)
            button.btn.btn-primary(type="submit", data-testid="-btn-submit") 変更
            |
            |
            router-link.btn.btn-default(:to="{name: 'top'}", data-testid="-btn-back") キャンセル

        +btnbar

        div.callout.callout-info.bcard-callout
          p 自身の代わりに代理操作をするユーザーを <strong>2 人 まで</strong> 選択できます。
            br
            | [ユーザー選択]ボタンを押下し、ユーザーを選択してください。

        .box.box-widget
          //- .box-header.with-border
            .box-title
              |
              |
              | 1人目
          .box-body
            loading(v-if="initLoading", :height="48")
            div.form-group(v-else)
              sel-users(
                v-model="agents",
                input-name="agents[]",
                :max-select="2",
                @input="watchValidateAgent"
              )

        +btnbar(class='-bottom')
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import SelUsers from '@/components/organisms/SelUsers'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AgentRepository = RepositoryFactory.get('agents')

export default {
  name: 'AgentSetting',
  components: { AppMessages, SelUsers, Loading },
  data: function () {
    return {
      // 初回ローディング
      initLoading: true,
      // 選択済みユーザー
      agents: []
    }
  },
  // 最初にこの機能に入ってきたときに実行される
  created: function () {
    const vm = this

    // API実行
    AgentRepository.get()
      .then(function (response) {
        const data = vm.getApiData(response).data
        vm.agents = data
        vm.initLoading = false
      })
      // エラー時処理
      .catch(function (error) {
        vm.errors.push(vm.setErrorMessage(error))
      })
  },
  methods: {
    watchValidateAgent: function () {
      this.clearMessages()
      const loginUserId = this.$store.getState('login_user').id
      // 自分は選択できないのでチェックする
      for (let agent of this.agents) {
        if (agent.id === loginUserId) { // Number同士
          // this.agents.splice(index, 1)
          this.setAgentError()
          break
        }
      }
    },
    /**
     * 代理ユーザー選択エラーメッセージを表示する
     */
    setAgentError: function (index) {
      this.errors = ['代理操作ユーザーには自分を設定できません。']
    },
    // 送信処理
    postData: function () {
      const vm = this
      let agents = []
      for (let agent of this.agents) {
        if (agent.id) {
          agents.push({
            sid_assign: agent.id
          })
        }
      }
      // API実行
      AgentRepository.post({agents: agents})
        .then(function () {
          // 処理成功時はTOPに遷移する
          vm.$router.push({name: 'top'})
        }).catch(function (error) {
          // エラーメッセージを出す
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/prsettings/AgentSetting.vue